import React from "react";
import { Typography, Row, Col, Card, Image, Divider } from "antd";
import PageLayout from "./PageLayout";
import { useTranslation } from "react-i18next";

const { Title, Paragraph } = Typography;

const About = () => {
  const { t } = useTranslation();

  return (
    <PageLayout>
      <Card
        bordered={false}
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          marginBottom: "48px",
          position: "relative",
          height: "400px",
        }}
        bodyStyle={{
          padding: 0,
          height: "400px",
          position: "relative",
        }}
      >
        <Image
          src="https://www.atlasandboots.com/wp-content/uploads/2019/05/ama-dablam2-most-beautiful-mountains-in-the-world.jpg"
          alt="Mountain landscape"
          preview={false}
          width="100%"
          height="400px"
          style={{
            objectFit: "cover",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Title level={1} style={{ color: "#fff", margin: 0 }}>
            {t('aboutPage.heroTitle')}
          </Title>
        </div>
      </Card>

      <Row gutter={[48, 48]} align="middle" style={{ marginBottom: "48px" }}>
        <Col xs={24} md={12}>
          <Card
            bordered={false}
            style={{
              borderRadius: "12px",
              padding: "24px",
            }}
          >
            <Title level={4}>
              {t('aboutPage.welcomeTitle')}
            </Title>
            <Divider/>
            <Paragraph style={{ fontSize: "16px", lineHeight: "1.8" }}>
              {t('aboutPage.paragraph1')}
            </Paragraph>
            <Paragraph style={{ fontSize: "16px", lineHeight: "1.8" }}>
              {t('aboutPage.paragraph2')}
            </Paragraph>
            <Paragraph style={{ fontSize: "16px", lineHeight: "1.8" }}>
              {t('aboutPage.paragraph3')}
            </Paragraph>
          </Card>
        </Col>
        <Col xs={24} md={12}>
          <Card
            bordered={false}
            style={{
              borderRadius: "12px",
              overflow: "hidden",
            }}
          >
            <Image
              src="https://i0.wp.com/bimbinlombardia.com/wp-content/uploads/2021/12/Tirano-.jpg"
              alt="Ca' De Campo Exterior"
              style={{ width: "100%", height: "470px" }}
            />
          </Card>
        </Col>
      </Row>
    </PageLayout>
  );
};

export default About;
